/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * State Definition
 *
 * @type {Object}
 */
const state = {
    context: null,
    selectedStep: 0,
    imported_success: false,
    upload: {
        success: false,
        active: false,
        error: {},
        requestingAssistance: false,
        fileAssisted: false
    },
    data: {
        rentroll: {
            assistanceRequested: false,
            assistanceSuccess: false,
            assistanceMessage: null,
            attemptingImport: false,
            uploaded: false,
            loading: false,
            error: null,
            remapping: false,
            showTab: 0,
            data: {
                date: null,
                file_name: null,
                summary: {},
                table_data: {
                    data: [],
                    meta: {
                        number_of_rows: 0
                    }
                }
            },
            meta: {
                rentroll_file_id: null,
                assignment_options: {}
            },
            pagination: {
                currentPage: 1,
                pageLimit: 18
            },
            mapping: {}
        },
        pnl: {
            data: {}
        }
    },
    analysis: {
        loading: false,
        error: false,
        activeKey: 'opex',
        filterTerm: null,
        selectedItem: {},
        data: {
            meta: {
                time_frames: []
            },
            miscinc: {
                general: [],
                line_items: []
            },
            opex: {
                general: [],
                line_items: []
            }
        }
    },
    classification: {
        showInputBindings: true
    },
    importing: false,
    importSuccess: false
}

/**
 * Return a state copy
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/importer/state.js